(() => {
  const hostSelector = '#aftersell-pdp-upsell';
  const productCache = new Map();
  let shadowObserver;

  function getProduct(handle) {
    if (!productCache.has(handle)) {
      productCache.set(
        handle,
        fetch(`/products/${encodeURIComponent(handle)}.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        })
          .then((response) => (response.ok ? response.json() : null))
          .catch(() => null)
      );
    }

    return productCache.get(handle);
  }

  function getBadge(product) {
    if (!product) return null;

    const tags = (product.tags || []).map((tag) => String(tag).toLowerCase());
    const isDiscounted = product.compare_at_price > product.price;

    if (!product.available) return { label: 'Sold Out', type: 'sold-out' };
    if (tags.includes('bundle')) return { label: 'Bundle', type: 'bundle' };
    if (tags.includes('bulk') && isDiscounted) return { label: 'Bulk Savings', type: 'bulk' };
    if (isDiscounted) return { label: 'Sale', type: 'sale' };

    return null;
  }

  function getHandle(card) {
    const href = card.querySelector('.product-image-wrapper a[href*="/products/"]')?.href;
    if (!href) return null;

    return new URL(href, window.location.origin).pathname.match(/^\/products\/([^/]+)/)?.[1] || null;
  }

  function addStyles(shadowRoot) {
    if (shadowRoot.getElementById('cryo-product-card-badge-styles')) return;

    const style = document.createElement('style');
    style.id = 'cryo-product-card-badge-styles';
    style.textContent = `
      .product-image-wrapper { position: relative; }
      .cryo-product-card-badge {
        position: absolute;
        bottom: 12px;
        left: 12px;
        z-index: 2;
        padding: 5px 12px;
        border: 1px solid;
        border-radius: 30px;
        font-family: Gilroy, sans-serif;
        font-size: 13px;
        font-weight: 700;
        line-height: 1.2;
        pointer-events: none;
      }
      .cryo-product-card-badge--bundle {
        background: #fff;
        border-color: #e07e24;
        color: #cd4b24;
      }
      .cryo-product-card-badge--bulk {
        background: #cd4820;
        border-color: #ffdb1d;
        color: #fff;
      }
      .cryo-product-card-badge--sale {
        background: #fff;
        border-color: #314058;
        color: #314058;
      }
      .cryo-product-card-badge--sold-out {
        background: #314058;
        border-color: #314058;
        color: #fff;
      }
    `;
    if (window.location.pathname.endsWith('/products/mit-milk')) {
      style.textContent += '.pdp-widget .upsell-header { line-height: 1.15; }';
    }
    shadowRoot.append(style);
  }

  async function decorateCard(card) {
    const handle = getHandle(card);
    if (!handle || card.dataset.cryoBadgeHandle === handle) return;

    card.dataset.cryoBadgeHandle = handle;
    card.querySelector('.cryo-product-card-badge')?.remove();

    const product = await getProduct(handle);
    if (card.dataset.cryoBadgeHandle !== handle) return;

    const badge = getBadge(product);
    const imageWrapper = card.querySelector('.product-image-wrapper');
    if (!badge || !imageWrapper) return;

    const element = document.createElement('span');
    element.className = `cryo-product-card-badge cryo-product-card-badge--${badge.type}`;
    element.textContent = badge.label;
    imageWrapper.append(element);
  }

  function decorate(shadowRoot) {
    addStyles(shadowRoot);
    shadowRoot.querySelectorAll('.product-card').forEach(decorateCard);
  }

  function connect() {
    const shadowRoot = document.querySelector(hostSelector)?.shadowRoot;
    if (!shadowRoot) return false;

    decorate(shadowRoot);
    shadowObserver = new MutationObserver(() => decorate(shadowRoot));
    shadowObserver.observe(shadowRoot, {
      attributes: true,
      attributeFilter: ['href'],
      childList: true,
      subtree: true,
    });
    return true;
  }

  if (!connect()) {
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (connect() || attempts >= 60) window.clearInterval(timer);
    }, 250);
  }
})();
